<template>
	<div id="UI" class="fullSize">

		

		<ContentPanel v-bind:App="App" v-if="App.contentPanelVisible" />
		<BreadCrumbs v-bind:App="App" />
		

		<div id="mainTitle" class="title_bold" ref="mainTitle" 
		v-bind:class="'size_'+getTitleSize()"
		v-html="App.getCurrentTitle()"
		v-show="!App.viewMode.map"
		></div>

		<div id="nav_area"
		v-bind:class="[App.menuOpen || App.viewMode.map ? 'opened' : 'hidden', App.viewMode.map ? 'map' : null ]">

			<div id="nav_area_mobile_open"
			v-on:click="toggleMenuNav">
				<div class="menubar one"></div>
				<div class="menubar two"></div>
				<div class="menubar three"></div>
			</div>

			<div id="nav_next"
			v-bind:class=" [App.viewMode.map ? 'hidden' : null ]">

				<div id="nav_next_list_wrap"
				v-if="App.getNextNavPoints().length > 0">

					<div id="nav_next_list_title" class="title_bold" v-html="App.getNavTitle()">Navigation</div>

					<div id="nav_next_list" class="text_light">
						<ul>
							<li v-for="(node, nodeIndex) in  App.getNextNavPoints()" v-bind:key="nodeIndex"
							v-html="node.title"
							v-on:click="moveToNode(node)"></li>
						</ul>
					</div>
				</div>

				<div class="left_button button back title_bold"
				v-if="!App.isFirstNode()"
				v-on:click="prevNode()">
					<span>{{ App.lang.get('Back') }}</span>
					<div class="icon back"></div>
				</div>

			</div>

			<div class="left_button button map title_bold"
			v-bind:class="App.viewMode.map ? 'opened' : 'closed'"
			v-on:click="mapMode">
				<span v-html="App.viewMode.map ? App.lang.get('Close map') : App.lang.get('View map')">{{ App.lang.get('View map') }}</span>
				<div class="icon" v-bind:class="App.viewMode.map ? 'close' : 'map'"></div>
			</div>
		</div>

		
		
	</div>
</template>

<script>
import ContentPanel from './ContentPanel.vue'
import BreadCrumbs from './BreadCrumbs.vue'

export default {
	name: 'UI',
	props: {
		App: Object
	},
	components: {
		ContentPanel,
		BreadCrumbs
	},
	data : function() {
		return {
		}
	},
	mounted() {
		//console.log(this.App)
	},
	created() {
	},
	methods : {
		getTitleSize() {
			var l = this.App.currentNode != null ? this.App.currentNode.title.length : 14;
			if(l <= 16)
				return 1
			else if (l <= 30)
				return 2
			else if (l <= 46)
				return 3
			else
				return 4
		},

		moveCamEventTest() {
			document.dispatchEvent(this.App.events.moveCamera);
		},

		mapMode() {
			this.App.menuOpen = false;
			document.dispatchEvent(this.App.events.mapToggle);
		},

		moveToNode(node) {
			this.App.nextNode = node;
			document.dispatchEvent(this.App.events.moveToNextNode);
		},

		prevNode() {
			document.dispatchEvent(this.App.events.moveToPrevNode);
		},

		toggleMenuNav() {
			this.App.menuOpen = !this.App.menuOpen
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
